import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
// import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { SecureStorage } from '@ionic-native/secure-storage/ngx';
import { PreviewAnyFile } from '@ionic-native/preview-any-file/ngx';

import { ComponentsModule } from './components/components.module';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Vibration } from '@ionic-native/vibration/ngx';

import { MomentModule } from 'ngx-moment';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { AppAvailability } from '@ionic-native/app-availability/ngx';

import { IntroPageModule } from './pages/intro/intro.module';
import { AuthPageModule } from './pages/auth/auth.module';
import { SentryErrorHandler } from './providers/sentry-service/sentry-service';
import { NFC } from '@ionic-native/nfc/ngx';
// import { BaiduPush } from '@ionic-native/baidu-push/ngx';
import { CloudSettings } from '@ionic-native/cloud-settings/ngx';

import { CameraPreview } from '@ionic-native/camera-preview/ngx';
import { QRScanner } from '@ionic-native/qr-scanner/ngx';
import { CommonComponentsModule } from '@arianeeprivate/wallet-shared-components';
import { CommonModule } from '@angular/common';
import { FakeLoginModule } from './pages/fakeLogin/fakeLogin.module';

export function createTranslateLoader (http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

const providersArray:any = [
  AndroidPermissions,
  CameraPreview,
  StatusBar,
  // SplashScreen,
  SecureStorage,
  NativeStorage,
  PreviewAnyFile,
  FingerprintAIO,
  InAppBrowser,
  SocialSharing,
  Vibration,
  AppVersion,
  Clipboard,
  AppAvailability,
  NFC,
  // BaiduPush,
  CloudSettings,
  QRScanner,
  { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  { provide: ErrorHandler, useClass: SentryErrorHandler }
];

@NgModule({
  declarations: [
    AppComponent
  ],
  entryComponents: [
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ swipeBackEnabled: false }),
    AppRoutingModule,
    TranslateModule.forRoot({
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    ComponentsModule,
    MomentModule,
    IntroPageModule,
    AuthPageModule,
    FakeLoginModule,
    CommonComponentsModule,
    CommonModule
  ],
  providers: providersArray,
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
